import React, { useState } from "react";
import { getEmployeeSuggestions } from "../../../../Auth/Services/metadataService";
import { assignJobToEmployee } from "../Services/DraftJobService";
import Cookies from "js-cookie";
import { handleOutsideClick } from "../../../../Helpers/HandleOutsideClick";

const AssignRecruiterModal = ({
  show,
  onClose,
  jobUID,
  onSuccess,
  handleKeyDown,
  handleSelectSuggestion
}) => {
  const token = Cookies.get("employeeToken");

  const [employeeCode, setEmployeeCode] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  if (!show) return null;

  const handleChange = async (value) => {
    setEmployeeCode(value);

    if (value.trim().length > 1) {
      try {
        const res = await getEmployeeSuggestions(value.trim());

        if (res?.length > 0) {
          setSuggestions(res);
          setShowSuggestions(true);
        } else {
          setSuggestions([]);
          setShowSuggestions(false);
        }
      } catch {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const res = await assignJobToEmployee(
        jobUID,
        employeeCode.split(" - ")[0],
        token
      );

      if (res.data.status === "Success") {
        onSuccess(res.data.message);
        setEmployeeCode("");
        setEmployeeName("");
        onClose();
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("Unable to assign recruiter.");
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center"
      onClick={(e) => handleOutsideClick(e, onClose)}>
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-white w-full max-w-md rounded-2xl shadow-xl p-6 z-10">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-semibold text-[#2563eb]">
            Assign Recruiter
          </h3>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="relative">
          <label className="block text-sm font-medium mb-2">
            Recruiter Code / Name
          </label>

          <input
            type="text"
            value={employeeCode}
            onChange={(e) => handleChange(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#2563eb]"
            placeholder="Type recruiter code or name"
          />

          {showSuggestions && suggestions.length > 0 && (
            <ul className="absolute z-50 mt-1 w-full bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
              {suggestions.map((s) => (
                <li
                  key={s.employeeCode}
                  onClick={() => {
                    setEmployeeCode(`${s.employeeCode} - ${s.employeeName}`);
                    setEmployeeName(s.employeeName);
                    setShowSuggestions(false);
                  }}
                  className="px-3 py-2 text-sm hover:bg-[#2563eb] hover:text-white cursor-pointer"
                >
                  {s.employeeCode} - {s.employeeName}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={!employeeCode || !employeeName}
            className="px-4 py-2 bg-primary text-white rounded-md"
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignRecruiterModal;
